import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { DomainDataService } from '@mitsubishi/core';
import { NewsTagContextEnum } from '@mitsubishi/news/data-access';

type SearchFnResponse = {
  context: NewsTagContextEnum;
  key: string;
  value: string;
};

@Component({
  selector: 'apm-news-admin-dialog-tag-step',
  templateUrl: './news-admin-dialog-tag-step.component.html',
  styleUrls: ['./news-admin-dialog-tag-step.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NewsAdminDialogTagStepComponent {
  form = input.required<UntypedFormGroup>();

  classes$ = this.domainDataService.getClasses().pipe(
    map(values =>
      values.map(v => ({
        context: NewsTagContextEnum.Class,
        key: v.id.toString(),
        value: v.descriptionId,
      }))
    )
  );
  subClasses$ = this.domainDataService.getSubClasses().pipe(
    map(values =>
      values.map(v => ({
        context: NewsTagContextEnum.Subclass,
        key: v.id.toString(),
        value: v.descriptionId,
      }))
    )
  );
  subFamiliesSearchFn = (searchTerm: string): Observable<SearchFnResponse[]> =>
    this.domainDataService.getSubFamilies(searchTerm).pipe(
      map(values =>
        values.map(v => ({
          context: NewsTagContextEnum.Subfamily,
          key: v.subfamilyId.toString(),
          value: v.subfamilyCode,
        }))
      )
    );
  modelsSearchFn = (searchTerm: string): Observable<SearchFnResponse[]> =>
    this.domainDataService.getModels(searchTerm).pipe(
      map(values =>
        values.map(v => ({
          context: NewsTagContextEnum.Model,
          key: v.formattedModelId,
          value: v.modelCode,
        }))
      )
    );

  constructor(private domainDataService: DomainDataService) {}

  subFamiliesCompareFunction = (obj1: SearchFnResponse, obj2: SearchFnResponse) => obj1.key === obj2.key;
  modelsCompareFunction = (obj1: SearchFnResponse, obj2: SearchFnResponse) => obj1.key === obj2.key;
}
